import { axiosRequest } from "@/lib/axios";
import type {
	BrandKit,
	BrandKitLogoErrorResponse,
	BrandKitFaviconResponse,
	BrandKitLogoIconOnlyResponse,
	BrandKitLogoIconWithLabelResponse,
	BrandKitLogoInvertedIconOnlyResponse,
	BrandKitLogoInvertedIconWithLabelResponse,
	BrandKitLogoInvertedLabelOnlyResponse,
	BrandKitUpdateRequest,
} from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const brandKitApi = {
	view: async (workspaceId: string) => {
		return await axiosRequest<BrandKit>({ url: `${API_BASE_URL}/${workspaceId}/brandkit/self`, method: "GET" });
	},

	update: async (workspaceId: string, payload: BrandKitUpdateRequest) => {
		return await axiosRequest<BrandKit>({ url: `${API_BASE_URL}/${workspaceId}/brandkit`, data: payload, method: "PATCH" });
	},

	updateIconWithLabel: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("logo", file);

		return await axiosRequest<BrandKitLogoIconWithLabelResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-icon-with-label`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteIconWithLabel: async (workspaceId: string) => {
		return await axiosRequest<BrandKitLogoIconWithLabelResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-icon-with-label`,
			method: "DELETE",
		});
	},

	updateLogoIconOnly: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("logo", file);

		return await axiosRequest<BrandKitLogoIconOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-icon-only`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteLogoIconOnly: async (workspaceId: string) => {
		return await axiosRequest<BrandKitLogoIconOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-icon-only`,
			method: "DELETE",
		});
	},

	updateLogoLabelOnly: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("logo", file);

		return await axiosRequest<BrandKitLogoIconOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-label-only`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteLogoLabelOnly: async (workspaceId: string) => {
		return await axiosRequest<BrandKitLogoIconOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-label-only`,
			method: "DELETE",
		});
	},

	updateFavicon: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("favicon", file);

		return await axiosRequest<BrandKitFaviconResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/favicon`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteFavicon: async (workspaceId: string) => {
		return await axiosRequest<BrandKitFaviconResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/favicon`,
			method: "DELETE",
		});
	},

	updateLogoInvertedIconOnly: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("logo", file);

		return await axiosRequest<BrandKitLogoInvertedIconOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-inverted-icon-only`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteLogoInvertedIconOnly: async (workspaceId: string) => {
		return await axiosRequest<BrandKitLogoInvertedIconOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-inverted-icon-only`,
			method: "DELETE",
		});
	},

	updateLogoInvertedIconWithLabel: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("logo", file);

		return await axiosRequest<BrandKitLogoInvertedIconWithLabelResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-inverted-icon-with-label`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteLogoInvertedIconWithLabel: async (workspaceId: string) => {
		return await axiosRequest<BrandKitLogoInvertedIconWithLabelResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-inverted-icon-with-label`,
			method: "DELETE",
		});
	},

	updateLogoInvertedLabelOnly: async (workspaceId: string, file: File) => {
		const formData = new FormData();
		formData.append("logo", file);

		return await axiosRequest<BrandKitLogoInvertedLabelOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-inverted-label-only`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteLogoInvertedLabelOnly: async (workspaceId: string) => {
		return await axiosRequest<BrandKitLogoInvertedLabelOnlyResponse | BrandKitLogoErrorResponse>({
			url: `${API_BASE_URL}/${workspaceId}/brandkit/logo-inverted-label-only`,
			method: "DELETE",
		});
	},
};
